import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import { FaLink, FaImage, FaRegFilePdf, FaVideo, FaChevronRight } from "react-icons/fa";

import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Metatag from "../../hooks/Metatag";


export default function Initiatives() {
  const [show, setShow] = useState(false);
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    $(window).on("scroll", function () {
      $(".navbar").offset().top > 10 ? $(".fixed-top").removeClass("bg-header-home") : $(".fixed-top").removeClass("bg-header-home")
    });

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();


  }, []);


  return (
    <>
      <Header></Header>

      <Metatag title='IIT Bombay Campus Sustainability Assessment'
        description='IIT Bombay Campus Sustainability Assessment and Implementation Plan'
        keywords='IIT Bombay Campus Sustainability Assessment, IIT Bombay Campus Sustainability Plan, IIT Bombay Sustainability Tracking Assessment & Rating System - STARS'
      />

      {/* Visual Panel */}
      <Container fluid className="bg-visual-inside px-0" >
        <div className="visual-inside-big visual-container-inside">
          <Container >
            <Row className="g-md-0 rounded-4">
              <Col md={12}>
                <div className="py-md-4">
                  <div className="m-0 text-center py-xl-3 p-2 text-white">
                    <h1 className="fw-light text-white m-0 align-self-center wow fadeInUp">
                      Initiatives
                    </h1>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>

      {/* Container */}
      <Container className="my-5 pt-4 pt-xl-5">
        <div className="border rounded-4 p-xl-5 p-3 h-100">
          <Row className="row-cols-1 g-xl-5 g-4">
            <Col>
              <Row className="g-0">
                <Col md={8} lg={8} className="pe-lg-5 pe-md-4">
                  <h4 className="mb-3 wow fadeInUp">RePedal </h4>
                  <p className="wow fadeInUp">RePedal is an initiative under the Research Hub for Green Energy and Sustainability (GESH), IIT Bombay, to build a circular and sustainable bicycle ecosystem within the IIT Bombay campus. With hundreds of abandoned cycles annually, and a significant student interest in second-hand bicycles, this project aims to refurbish and redistribute bicycles to promote cycling as a safe, affordable, and eco-friendly transport mode.</p>
                </Col>
                <Col md={4} lg={4}>
                  <a href="https://repedal.netlify.app/" target="_blank">
                    <img src={global.variables.strDomainUrl + "images/pic-repedal-logo.jpg"} alt="" title="" className="img-fluid border rounded-3 w-100 wow fadeInUp" />
                  </a>
                </Col>
              </Row>
            </Col>
            <hr />
            <Col>
              <Row className="g-0">
                <Col md={8} lg={8} className="ps-lg-5 pe-md-4 order-lg-2">
                  <h4 className="mb-3 wow fadeInUp">PHO Dashboard </h4>
                  <p className="wow fadeInUp">GESH IITB has developed a digital dashboard for the Institute’s Public Health Office (PHO) to enable decentralised and streamlined data collection on waste generation and management. This tool empowers PHO to input data directly, fostering greater accountability and transparency. The centralised analysis of this data will support the PHO in identifying patterns, guiding strategic and operational decisions, and driving long-term improvements in waste reduction and effective segregation across the campus.</p>

                </Col>
                <Col md={4} lg={4} className="order-lg-1">
                  <a href="https://pho-datapool.streamlit.app/" target="_blank">
                    <img src={global.variables.strDomainUrl + "images/pic-pho-dashboard.jpg"} alt="" title="" className="img-fluid border rounded-3 w-100 wow fadeInUp" />
                  </a>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Container>

      {/* Breadcrumb */}
      <Breadcrumb className="breadcrumb-panel mt-auto">
        <Breadcrumb.Item href={global.variables.strDomainUrl}>Home</Breadcrumb.Item>
        <Breadcrumb.Item active>Campus Sustainability</Breadcrumb.Item>
        <Breadcrumb.Item active>Sustainability @ IITB</Breadcrumb.Item>
        <Breadcrumb.Item active>Initiatives</Breadcrumb.Item>
      </Breadcrumb>
    </>
  );
}